import { HOW_WORKS_TYPE, PAYMENT_METHODS_TYPE } from "Types";

import { PATHS_NAME } from "./PathName.Constant";

export const STATUS_CODES = {
  SERVER_NOT_RESPONSE: "ECONNABORTED",
  INTERNAL_SERVER_ERROR: 500,
  NO_INTERNET: 0,
  TOO_MANY_REQUESTS: 429,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
};

export const KEYS = {
  TOKEN: "auth_token",
};

export const PAGE_THEME = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  PURPLE: "purple",
  WHITE: "white",
  GRADIENT: "gradient",
  NONE: "none",
  PURPLE_GRAY: "purple-gray",
  DARK_BLUE: "dark-blue",
};

export const SUPPORT_EMAIL = "support@helloclever.co";
export const BUSINESS_EMAIL = "partnerships@helloclever.co";

export const DEFAULT_SEO_TITLE =
  "Hello Clever | Shop with brands you love, earn instant cashback with Hello Clever";

export const DEFAULT_SEO_DESCRIPTION =
  // eslint-disable-next-line max-len
  "The first Australian buy-to-earn platform that makes shopping, payments, and money management easier for all. Trusted by 100,000+ Australians and 1,000+ merchants. Join us now!";

export const MAX_CONTENT_WIDTH = 1440;
export const MAX_INNER_CONTENT_WIDTH = 1400;
export const MAX_FOOTER_WIDTH = 1400;

export const ALERT_BANNER_HEIGHT = 50; // px
export const DEFAULT_HEADER_HEIGHT = 115;
export const HEADER_HEIGHT = 100 + ALERT_BANNER_HEIGHT; // px

export const PAYMENT_METHODS = {
  BUY_TO_EARN: "buy_to_earn" as PAYMENT_METHODS_TYPE,
  PAY_ID: "pay_id" as PAYMENT_METHODS_TYPE,
  PAY_TO: "pay_to" as PAYMENT_METHODS_TYPE,
  CARD: "card" as PAYMENT_METHODS_TYPE,
};

export const HOW_WORKS = {
  STEP_ONE: "step_one" as HOW_WORKS_TYPE,
  STEP_TWO: "step_two" as HOW_WORKS_TYPE,
  STEP_THREE: "step_three" as HOW_WORKS_TYPE,
};

export const REVALIDATE_TIME = 60 * 10; // 10 minutes

export const METADATA_TITLE = {
  home: "Hello Clever | Real-Time Payments & Instant Cashback Rewards",
  about: "Hello Clever | About",
  getInTouch: "Hello Clever | Contact",
  policy: "Hello Clever | Privacy Policy",
  terms: "Hello Clever | Terms and Conditions",

  blogs: "Hello Clever | Blogs",
  blog: "Hello Clever | ",
  caseStudies: "Hello Clever | Case Studies",
  caseStudy: "Hello Clever | ",
  shops: "Hello Clever | Shops",
  shop: "Hello Clever | ",

  paymentRequest: "Hello Clever | Payment Request",

  eCommerce:
    "Hello Clever | PayID, PayTo & Instant Cashback Solution for E-commerce",
  industries: "Hello Clever | Real-time Payments for Billers",

  selectBank: "Hello Clever | Banks",
  qrCode: "Hello Clever | Qr Code",
  salesReport: "Hello Clever | Sales Report",
  payto:
    "Hello Clever | PayTo - Real-Time Recurring Payments with Instant Cashback",
  status: "Hello Clever | Status",
  xero: "Hello Clever | PayID and PayTo for Xero",

  tyroConsumer: "Hello Clever | PayID Consumer",
  inStore: "Future of Rewards | Instant Cashback by Hello Clever",
  inStoreLoyalty: "In-Store Loyalty Rewards for SMBs | Tyro + Hello Clever",
  "500": "Hello Clever | 500",
  "404": "Hello Clever | 404",
  demoForecast: "Hello Clever | AI Forecast",
  demoOverviewAndInsights: "Hello Clever | Overview and Insights",
  embeddedLoyalty:
    "Hello Clever | Drive New Repeat Business with Instant Cashback Embedded Loyalty",
  milestoneRewards: "Milestone Rewards | Drive Retention with Every Tap",
};
export const METADATA_DESCRIPTION = {
  home: "Hello Clever is a global fintech platform revolutionising real-time payments with embedded loyalty, driving engagement and impactful connections for businesses and consumers alike.",
  payto:
    "Our low-cost, simple PayTo solution allows you to collect recurring and one-off payments directly from customers' bank accounts in real-time.",
  xero: "Get your invoices paid in real-time and improve your cashflow.",
  inStore:
    "Drive new customers in-store and reward regulars with Hello Clever's Instant POS Cashback solution. First 3 months free. Sign up today!",
  inStoreLoyalty:
    "Make every tap count. Offer instant cashback, milestone rewards, and real-time insights through Tyro EFTPOS with Hello Clever. Fast setup, real results, and local-based support.",
  eCommerce:
    "Receive funds instantly with real-time customer payments. A low-cost plugin for WooCommerce, Shopify, Magento, OpenCart, or custom builds.",
  industries:
    "Bring your outdated BPAY and Direct Debit payment options into the future with Hello Clever PayTo and PayID for Business.",
  paymentRequest:
    "Hello Clever’s Payment Link Request feature allows merchants to send secure, customisable payment links directly to customers via SMS, email, or social media.",
  demoForecast:
    "Stay ahead with AI Forecast – your go-to resource for insights, trends, and predictions in artificial intelligence, machine learning, and emerging technologies.",
  demoOverviewAndInsights:
    "Unlock deep data-driven insights with AI-powered analytics. Transform complex data into actionable intelligence for smarter decisions and business growth.",
  embeddedLoyalty:
    "Forget points. Embed Instant Cashback Rewards into your payment flow and turn first-time buyers into loyal customers—without cutting margins. See how it works.",
  milestoneRewards:
    "Keep them coming back. Milestone Rewards turns everyday taps into loyalty magic—boosting retention, without the stamp cards or checkout clunk.",
};

export const CASE_STUDY_TAG = "Case Study";
export const ALL_CATEGORIES_TAG = "All Categories";
export const BLOG_CATEGORY = {
  ALL_CATEGORIES: {
    name: "All Categories",
    slug: "all_categories",
  },
  LEARN: {
    name: "Learn",
    slug: "learn",
  },
  NEWS: {
    name: "News",
    slug: "news",
  },
  PEOPLE: {
    name: "People",
    slug: "people",
  },
  PRODUCT: {
    name: "Product",
    slug: "product",
  },
  CASE_STUDY: {
    name: "Case Study",
    slug: "case-study",
  },
};

export const CASE_STUDY_TITLE = "Case Study";
export const CASE_STUDY_SLUG =
  "a-recipe-for-success-how-cake-creations-by-kate-grew-with-hello-clevers-real-time-payments";

export const BIG_FOUR_BANKS_IDS = [1, 2, 4, 5];

export const NAME_MAX_LENGTH = 200;
export const MESSAGE_MAX_LENGTH = 1000;

export const DATE_TIME_FORMAT_FE = "MMM DD, YYYY";

export const BLOGS_CONTANT = {
  EMBEDDED: "_embedded",
  MEDIA: "wp:featuredmedia",
  TERM: "wp:term",
};

export const SHOW_ALERT_URLS = [
  PATHS_NAME.HOME,
  PATHS_NAME.ABOUT,
  PATHS_NAME.MILESTONE_REWARDS,
];
